export const GET_AFFILIATE_SETTING = 'GET_AFFILIATE_SETTING';
export const SET_AFFILIATE_SETTING = 'SET_AFFILIATE_SETTING';
export const POST_AFFILIATE_SETTING = 'POST_AFFILIATE_SETTING';
